import Button from '@rio-cloud/rio-uikit/Button';

export const FilterResetButton = ({
    hasActiveFilter,
    onResetFilter,
    trackingKey,
}: {
    hasActiveFilter: boolean;
    onResetFilter: () => void;
    trackingKey: string;
}) => {
    if (!hasActiveFilter) {
        return null;
    }

    return (
        <Button bsStyle='default' iconOnly autoTrackingKey={trackingKey} onClick={onResetFilter}>
            <span className='rioglyph rioglyph-filter-active ' />
        </Button>
    );
};
